/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Transit_DescInputs */

const es_privacy_policy_security_transit_desc = /** @type {(inputs: Privacy_Policy_Security_Transit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLS 1.2 o superior para todas las comunicaciones entre su navegador y nuestros servidores.`)
};

const en_privacy_policy_security_transit_desc = /** @type {(inputs: Privacy_Policy_Security_Transit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLS 1.2 or higher for all communications between your browser and our servers.`)
};

/**
* | output |
* | --- |
* | "TLS 1.2 or higher for all communications between your browser and our servers." |
*
* @param {Privacy_Policy_Security_Transit_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_transit_desc = /** @type {((inputs?: Privacy_Policy_Security_Transit_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Transit_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_transit_desc(inputs)
	return en_privacy_policy_security_transit_desc(inputs)
});
export { privacy_policy_security_transit_desc as "privacy_policy.security.transit_desc" }